import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

// import ReloadIcon from "../../../assets/svg/ReloadIcon";
import { Helmet } from "react-helmet";
import Loader from "../../../components/common/Loader/Loader";
import Pagination from "../../../components/common/new/Pagination/Pagination";
import useUserConfig from "../../../hooks/useUserConfig";
import { Constants, AlertStatus } from "../../../contants";
import { selectAllSIUsers } from "../../../redux/selectors/user";
import styles from "../EmailerRecipients/EmailerReceipients.styles";
import { performOperation } from "../EmailerRecipients/utils";
import { ToastAlertContext } from "../../../config/providers/ToastAlert";
import Emailer from "../../../services/api/emailer";
import ViewRecipientsTable from "./ViewRecipients";

const LOADER_DELAY = 1000;

function ViewRecipients() {
  const TITLE = "View Email Recipients - BSG";
  const [searchData, setSearchData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { isHelpDesk, isHelpDeskAdmin } = useSelector(selectAllSIUsers);
  const hasPermission = useUserConfig();
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [pageSize, setPageSize] = useState(Constants.DEFAULT_PAGE_SIZE);
  const toast = useContext(ToastAlertContext);
  const { id } = useParams();

  const fetchSearchData = async (
    pageNumber,
    size = Constants.DEFAULT_PAGE_SIZE
  ) => {
    try {
      setIsLoading(true);
      const { data } = await Emailer.getRecipients({
        templateId: id,
        pageNumber,
        size,
      });

      // Showing some delay to avoid loader flicker issue
      setTimeout(() => {
        setSearchData(data.content);
        setCurrentPage(data.number);
        setTotalPages(data.totalPages);
        setTotalElements(data.totalElements);
        setPageSize(data.size);
        setIsLoading(false);
      }, LOADER_DELAY);
    } catch (error) {
      setIsLoading(false);
      toast.show(
        error.message || "Something went wrong. Please contact support.",
        AlertStatus.ERROR
      );
      console.error(error);
    }
  };

  const onPaginationClick = (page) => {
    fetchSearchData(page, pageSize);
  };

  const onPageSizeClick = (operator) => {
    const newPageSize = performOperation(
      pageSize,
      Constants.DEFAULT_PAGE_SIZE,
      operator
    );
    fetchSearchData(0, newPageSize);
  };

  useEffect(() => {
    fetchSearchData(currentPage, pageSize);
    // resetFormState();
  }, [currentPage, pageSize]);

  const onRefresh = () => {
    fetchSearchData(0, Constants.DEFAULT_PAGE_SIZE);
  };

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <div style={styles.container}>
        <div style={styles.filter}>
          <div style={styles.right}>
            {/* <div style={styles.reload} onClick={onRefresh}>
      <ReloadIcon />
    </div> */}
          </div>
        </div>
        <div style={styles.main}>
          <ViewRecipientsTable
            searchData={searchData}
            currentPage={currentPage}
            pageSize={pageSize}
            hasPermission={hasPermission}
            showStatusColumn={isHelpDesk || isHelpDeskAdmin}
            totalElements={totalElements}
            templateId={id}
            onRefresh={onRefresh}
          />
          {searchData.length ? (
            <div style={styles.pagination}>
              <Pagination
                totalPages={totalPages}
                totalResults={totalElements}
                currentPage={currentPage}
                pageSize={pageSize}
                onChange={onPaginationClick}
                onPageSizeClick={onPageSizeClick}
              />
            </div>
          ) : null}
        </div>
        {isLoading && <Loader />}
      </div>
    </>
  );
}

export default ViewRecipients;
